import "./polyfills";

import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import { ClientStyleProvider } from "~/features/style/client-context";
import { initDatadog } from "./features/logging/init-datadog";
import { initDatadogRum } from "./features/logging/init-datadog-rum";
import { setupSwLogForwarding } from "./features/pwa/service-worker-log-forwarder";

import { onlineManager } from "@tanstack/react-query";

window.addEventListener("message", (event) => {
  for (const port of event.ports) {
    // Receive upcoming messages on this port.
    port.onmessage = (event) => {
      if (event.data === "PING") {
        port.postMessage("PONG");
      } else {
        alert(`Unknown postMessage received: ${event.data}`);
      }
    };
  }
});

onlineManager.setOnline(window.navigator.onLine);

initDatadog();
initDatadogRum();

function hydrate() {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <ClientStyleProvider>
          <HydratedRouter />
        </ClientStyleProvider>
      </StrictMode>,
    );
  });
}

if (typeof requestIdleCallback === "function") {
  requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}

// Set up listeners for logs from service workers.
setupSwLogForwarding();
